__turbopack_context__.v({
  "root": "LoadingArticleContent-module__pnPKLa__root",
});
